// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Fsession-protocol%2Fsrc%2Fmessages.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { SchemaObject } from '@augloop/types-core';
export class Message {
    constructor(obj) {
        SchemaObject.assign(Message, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_Message';
    }
    static getBaseTypes() {
        return [];
    }
    /**
     * Checks if passed schema object is of Message type or its inheritor and implements {@link IMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [Message.getTypeName()]);
    }
}
Message.H_ = { T_: Message.getTypeName(), B_: Message.getBaseTypes() };
export class Response {
    constructor(obj) {
        SchemaObject.assign(Response, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_Response';
    }
    static getBaseTypes() {
        return [];
    }
    /**
     * Checks if passed schema object is of Response type or its inheritor and implements {@link IResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [Response.getTypeName()]);
    }
}
Response.H_ = { T_: Response.getTypeName(), B_: Response.getBaseTypes() };
export class ErrorResponse {
    constructor(obj) {
        SchemaObject.assign(ErrorResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_ErrorResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of ErrorResponse type or its inheritor and implements {@link IErrorResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [ErrorResponse.getTypeName()]);
    }
}
ErrorResponse.H_ = { T_: ErrorResponse.getTypeName(), B_: ErrorResponse.getBaseTypes() };
export class TimeoutErrorResponse {
    constructor(obj) {
        SchemaObject.assign(TimeoutErrorResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_TimeoutErrorResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_ErrorResponse', 'AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of TimeoutErrorResponse type or its inheritor and implements {@link ITimeoutErrorResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [TimeoutErrorResponse.getTypeName()]);
    }
}
TimeoutErrorResponse.H_ = { T_: TimeoutErrorResponse.getTypeName(), B_: TimeoutErrorResponse.getBaseTypes() };
export class SessionInitMessage {
    constructor(obj) {
        SchemaObject.assign(SessionInitMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_SessionInitMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of SessionInitMessage type or its inheritor and implements {@link ISessionInitMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [SessionInitMessage.getTypeName()]);
    }
}
SessionInitMessage.H_ = { T_: SessionInitMessage.getTypeName(), B_: SessionInitMessage.getBaseTypes() };
export class SessionInitResponse {
    constructor(obj) {
        SchemaObject.assign(SessionInitResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_SessionInitResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of SessionInitResponse type or its inheritor and implements {@link ISessionInitResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [SessionInitResponse.getTypeName()]);
    }
}
SessionInitResponse.H_ = { T_: SessionInitResponse.getTypeName(), B_: SessionInitResponse.getBaseTypes() };
export class SessionCloseMessage {
    constructor(obj) {
        SchemaObject.assign(SessionCloseMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_SessionCloseMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of SessionCloseMessage type or its inheritor and implements {@link ISessionCloseMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [SessionCloseMessage.getTypeName()]);
    }
}
SessionCloseMessage.H_ = { T_: SessionCloseMessage.getTypeName(), B_: SessionCloseMessage.getBaseTypes() };
export class CacheDumpRequestMessage {
    constructor(obj) {
        SchemaObject.assign(CacheDumpRequestMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_CacheDumpRequestMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of CacheDumpRequestMessage type or its inheritor and implements {@link ICacheDumpRequestMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [CacheDumpRequestMessage.getTypeName()]);
    }
}
CacheDumpRequestMessage.H_ = { T_: CacheDumpRequestMessage.getTypeName(), B_: CacheDumpRequestMessage.getBaseTypes() };
export class CacheDumpRequestResponse {
    constructor(obj) {
        SchemaObject.assign(CacheDumpRequestResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_CacheDumpRequestResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of CacheDumpRequestResponse type or its inheritor and implements {@link ICacheDumpRequestResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [CacheDumpRequestResponse.getTypeName()]);
    }
}
CacheDumpRequestResponse.H_ = { T_: CacheDumpRequestResponse.getTypeName(), B_: CacheDumpRequestResponse.getBaseTypes() };
export class AnnotationActivationMessage {
    constructor(obj) {
        SchemaObject.assign(AnnotationActivationMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationActivationMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of AnnotationActivationMessage type or its inheritor and implements {@link IAnnotationActivationMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationActivationMessage.getTypeName()]);
    }
}
AnnotationActivationMessage.H_ = { T_: AnnotationActivationMessage.getTypeName(), B_: AnnotationActivationMessage.getBaseTypes() };
export class AnnotationActivationResponse {
    constructor(obj) {
        SchemaObject.assign(AnnotationActivationResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationActivationResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of AnnotationActivationResponse type or its inheritor and implements {@link IAnnotationActivationResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationActivationResponse.getTypeName()]);
    }
}
AnnotationActivationResponse.H_ = { T_: AnnotationActivationResponse.getTypeName(), B_: AnnotationActivationResponse.getBaseTypes() };
export class AnnotationResultStateMessage {
    constructor(obj) {
        SchemaObject.assign(AnnotationResultStateMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationResultStateMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of AnnotationResultStateMessage type or its inheritor and implements {@link IAnnotationResultStateMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationResultStateMessage.getTypeName()]);
    }
}
AnnotationResultStateMessage.H_ = { T_: AnnotationResultStateMessage.getTypeName(), B_: AnnotationResultStateMessage.getBaseTypes() };
export class AnnotationReleaseMessage {
    constructor(obj) {
        SchemaObject.assign(AnnotationReleaseMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationReleaseMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of AnnotationReleaseMessage type or its inheritor and implements {@link IAnnotationReleaseMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationReleaseMessage.getTypeName()]);
    }
}
AnnotationReleaseMessage.H_ = { T_: AnnotationReleaseMessage.getTypeName(), B_: AnnotationReleaseMessage.getBaseTypes() };
export class AnnotationReleaseResponse {
    constructor(obj) {
        SchemaObject.assign(AnnotationReleaseResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationReleaseResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of AnnotationReleaseResponse type or its inheritor and implements {@link IAnnotationReleaseResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationReleaseResponse.getTypeName()]);
    }
}
AnnotationReleaseResponse.H_ = { T_: AnnotationReleaseResponse.getTypeName(), B_: AnnotationReleaseResponse.getBaseTypes() };
export class AnnotationConfigUpdateMessage {
    constructor(obj) {
        SchemaObject.assign(AnnotationConfigUpdateMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationConfigUpdateMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of AnnotationConfigUpdateMessage type or its inheritor and implements {@link IAnnotationConfigUpdateMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationConfigUpdateMessage.getTypeName()]);
    }
}
AnnotationConfigUpdateMessage.H_ = { T_: AnnotationConfigUpdateMessage.getTypeName(), B_: AnnotationConfigUpdateMessage.getBaseTypes() };
export class AnnotationConfigUpdateResponse {
    constructor(obj) {
        SchemaObject.assign(AnnotationConfigUpdateResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationConfigUpdateResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of AnnotationConfigUpdateResponse type or its inheritor and implements {@link IAnnotationConfigUpdateResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationConfigUpdateResponse.getTypeName()]);
    }
}
AnnotationConfigUpdateResponse.H_ = { T_: AnnotationConfigUpdateResponse.getTypeName(), B_: AnnotationConfigUpdateResponse.getBaseTypes() };
export class SyncMessage {
    constructor(obj) {
        SchemaObject.assign(SyncMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_SyncMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of SyncMessage type or its inheritor and implements {@link ISyncMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [SyncMessage.getTypeName()]);
    }
}
SyncMessage.H_ = { T_: SyncMessage.getTypeName(), B_: SyncMessage.getBaseTypes() };
export class MicroSyncMessage {
    constructor(obj) {
        SchemaObject.assign(MicroSyncMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_MicroSyncMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of MicroSyncMessage type or its inheritor and implements {@link IMicroSyncMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [MicroSyncMessage.getTypeName()]);
    }
}
MicroSyncMessage.H_ = { T_: MicroSyncMessage.getTypeName(), B_: MicroSyncMessage.getBaseTypes() };
export class SyncResponse {
    constructor(obj) {
        SchemaObject.assign(SyncResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_SyncResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of SyncResponse type or its inheritor and implements {@link ISyncResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [SyncResponse.getTypeName()]);
    }
}
SyncResponse.H_ = { T_: SyncResponse.getTypeName(), B_: SyncResponse.getBaseTypes() };
export class SessionDeleteMessage {
    constructor(obj) {
        SchemaObject.assign(SessionDeleteMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_SessionDeleteMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of SessionDeleteMessage type or its inheritor and implements {@link ISessionDeleteMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [SessionDeleteMessage.getTypeName()]);
    }
}
SessionDeleteMessage.H_ = { T_: SessionDeleteMessage.getTypeName(), B_: SessionDeleteMessage.getBaseTypes() };
export class AnnotationResultsMessage {
    constructor(obj) {
        SchemaObject.assign(AnnotationResultsMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_AnnotationResultsMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_SyncMessage', 'AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of AnnotationResultsMessage type or its inheritor and implements {@link IAnnotationResultsMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [AnnotationResultsMessage.getTypeName()]);
    }
}
AnnotationResultsMessage.H_ = { T_: AnnotationResultsMessage.getTypeName(), B_: AnnotationResultsMessage.getBaseTypes() };
export class TokenProvisionMessage {
    constructor(obj) {
        SchemaObject.assign(TokenProvisionMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_TokenProvisionMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of TokenProvisionMessage type or its inheritor and implements {@link ITokenProvisionMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [TokenProvisionMessage.getTypeName()]);
    }
}
TokenProvisionMessage.H_ = { T_: TokenProvisionMessage.getTypeName(), B_: TokenProvisionMessage.getBaseTypes() };
export class TokenProvisionResponse {
    constructor(obj) {
        SchemaObject.assign(TokenProvisionResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_TokenProvisionResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of TokenProvisionResponse type or its inheritor and implements {@link ITokenProvisionResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [TokenProvisionResponse.getTypeName()]);
    }
}
TokenProvisionResponse.H_ = { T_: TokenProvisionResponse.getTypeName(), B_: TokenProvisionResponse.getBaseTypes() };
export class KeepAlive {
    constructor(obj) {
        SchemaObject.assign(KeepAlive, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_KeepAlive';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of KeepAlive type or its inheritor and implements {@link IKeepAlive}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [KeepAlive.getTypeName()]);
    }
}
KeepAlive.H_ = { T_: KeepAlive.getTypeName(), B_: KeepAlive.getBaseTypes() };
export class WorkflowGraphInitMessage {
    constructor(obj) {
        SchemaObject.assign(WorkflowGraphInitMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_WorkflowGraphInitMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of WorkflowGraphInitMessage type or its inheritor and implements {@link IWorkflowGraphInitMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [WorkflowGraphInitMessage.getTypeName()]);
    }
}
WorkflowGraphInitMessage.H_ = { T_: WorkflowGraphInitMessage.getTypeName(), B_: WorkflowGraphInitMessage.getBaseTypes() };
export class WorkflowGraphInitResponse {
    constructor(obj) {
        SchemaObject.assign(WorkflowGraphInitResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_WorkflowGraphInitResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of WorkflowGraphInitResponse type or its inheritor and implements {@link IWorkflowGraphInitResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [WorkflowGraphInitResponse.getTypeName()]);
    }
}
WorkflowGraphInitResponse.H_ = { T_: WorkflowGraphInitResponse.getTypeName(), B_: WorkflowGraphInitResponse.getBaseTypes() };
export class WorkflowExecutionCompleteMessage {
    constructor(obj) {
        SchemaObject.assign(WorkflowExecutionCompleteMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_WorkflowExecutionCompleteMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_SyncMessage', 'AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of WorkflowExecutionCompleteMessage type or its inheritor and implements {@link IWorkflowExecutionCompleteMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [WorkflowExecutionCompleteMessage.getTypeName()]);
    }
}
WorkflowExecutionCompleteMessage.H_ = { T_: WorkflowExecutionCompleteMessage.getTypeName(), B_: WorkflowExecutionCompleteMessage.getBaseTypes() };
export class OAuth2InitMessage {
    constructor(obj) {
        SchemaObject.assign(OAuth2InitMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_OAuth2InitMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of OAuth2InitMessage type or its inheritor and implements {@link IOAuth2InitMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [OAuth2InitMessage.getTypeName()]);
    }
}
OAuth2InitMessage.H_ = { T_: OAuth2InitMessage.getTypeName(), B_: OAuth2InitMessage.getBaseTypes() };
export class OAuth2InitResponse {
    constructor(obj) {
        SchemaObject.assign(OAuth2InitResponse, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_OAuth2InitResponse';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Response'];
    }
    /**
     * Checks if passed schema object is of OAuth2InitResponse type or its inheritor and implements {@link IOAuth2InitResponse}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [OAuth2InitResponse.getTypeName()]);
    }
}
OAuth2InitResponse.H_ = { T_: OAuth2InitResponse.getTypeName(), B_: OAuth2InitResponse.getBaseTypes() };
export class OAuth2CallbackMessage {
    constructor(obj) {
        SchemaObject.assign(OAuth2CallbackMessage, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Session_Protocol_OAuth2CallbackMessage';
    }
    static getBaseTypes() {
        return ['AugLoop_Session_Protocol_Message'];
    }
    /**
     * Checks if passed schema object is of OAuth2CallbackMessage type or its inheritor and implements {@link IOAuth2CallbackMessage}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [OAuth2CallbackMessage.getTypeName()]);
    }
}
OAuth2CallbackMessage.H_ = { T_: OAuth2CallbackMessage.getTypeName(), B_: OAuth2CallbackMessage.getBaseTypes() };
//# sourceMappingURL=messages.g.js.map